import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useResetUserPasswordMutation } from "../usersApi";

const ResetPasswordModal = ({ userId, onClose }) => {
  const show = Boolean(userId);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [resetPassword, { isLoading }] = useResetUserPasswordMutation();

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = async (values) => {
    try {
      await resetPassword({ userId, password: values.password }).unwrap();
      toast.success("Password reset - user must change it at next login");
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Could not reset password");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label">New Temporary Password</label>
          <input
            type="password"
            className="form-control"
            {...register("password", { required: true, minLength: 6 })}
          />
          {errors.password && (
            <div className="text-danger">
              Password is required (min 6 characters)
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Resetting..." : "Reset Password"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ResetPasswordModal;
